import { LOGIN_USER } from "../constants/types";
export const login = (data) => ({
  type: LOGIN_USER,
  data: data,
});

// export const logout = () => (dispatch) => {
//   AuthService.logout();
//   dispatch({
//     type: LOGOUT,
//   });
// };
